export const firebaseConfig = {
  apiKey: 'AIzaSyBaUXEaPHVmqN6LR7QUCVkssfk4QqfpBI4',
  authDomain: 'vs-platform-dev.firebaseapp.com',
  projectId: 'vs-platform-dev',
  storageBucket: 'vs-platform-dev.appspot.com',
  messagingSenderId: '318019831452',
  appId: '1:318019831452:web:a0b456476d44356ee84f59',
  measurementId: 'G-GT7CLTJ3JY',
};

export const firebaseConfigProd = {
  apiKey: 'AIzaSyC14Ou694TWThdXoa_D-NbXLVVvFX7y7FI',
  authDomain: 'vs-platform-efdba.firebaseapp.com',
  projectId: 'vs-platform-efdba',
  storageBucket: 'vs-platform-efdba.appspot.com',
  messagingSenderId: '792039738846',
  appId: '1:792039738846:web:53c612d3ccb3aed0e4614f',
  measurementId: 'G-GS5930PYPL',
};

export const firebaseConfigs = {
  sandbox: firebaseConfig,
  prod: firebaseConfigProd,
};
